import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format } from 'date-fns';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import {
  recordFiltering,
  findData,
} from '~/store/modules/EdicaoOperacao/TrocaTanque/actions';

import Form from './form';

export default function TrocaTanque() {
  const header = useMemo(
    () => [
      {
        id: 'datahorainiciotrocatanque',
        label: t('s.geral.opcoes.datahorainicial'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'datahorafimtrocatanque',
        label: t('s.geral.opcoes.datahorafinal'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.menu.configuracao.posto'),
        filter: { type: 'text' },
      },
      {
        id: 'idbico',
        label: t('s.configuracao.bico.idbico'),
        filter: { type: 'text' },
      },
      {
        id: 'idtanquevirtualanteriortrocatanque',
        label: t('s.operacao.edicaotrocatanque.tanqueanterior'),
      },
      {
        id: 'idtanquevirtualalinhadotrocatanque',
        label: t('s.operacao.edicaotrocatanque.tanquealinhado'),
      },
      { id: 'idusuario', label: t('s.operacao.recebimento.idusuario') },
    ],
    []
  );

  const redux = useSelector((state) => state.edicaoTrocaTanque);

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      form={Form}
      delete={false}
      detach="datahorainiciotrocatanque"
      keys="idtrocatanque"
    />
  );
}
